// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__3EG0Z","selectIcon":"Select_selectIcon__27qJ1"};